module.exports = __webpack_public_path__ + "img/de_Ecran 6.2ddc8aa7.jpg";